import localforage from "localforage";

/**
 * localforage stores for the offline Apollo cache + queued operations, plus
 * clear helpers (ported from the legacy services/cache.js — same store names,
 * so it shares storage with apollo/cache.ts and apollo/offlineLink.ts).
 */
export const cacheStore = localforage.createInstance({ name: "thruhiker", storeName: "cache" });
export const operationStore = localforage.createInstance({
  name: "thruhiker",
  storeName: "operations",
});

export const clearCacheStore = () =>
  cacheStore.clear().then(() => console.log("CacheStore cleared"));
export const clearOperationStore = () =>
  operationStore.clear().then(() => console.log("OperationStore cleared"));
